module.exports = __webpack_public_path__ + "static/media/CS1O1_EP2.4bdd5429.png";